import React from "react";
import { Tooltip, Button, Card, Space, Collapse } from "antd";
import {UserOutlined, DoubleRightOutlined, CloseOutlined, UserDeleteOutlined, EnvironmentOutlined} from "@ant-design/icons";
import { orderStatuses, taskButtonStatuses, userEmailAllow, userhasPermissionHelper, userReassignEmailAllow } from "../../../../../utils/Helpers";
import moment from "moment";
import { connect } from "react-redux";
import { PERMISSION_CONSTANT } from "../../../../../utils/constants/app";

const { Panel } = Collapse;
const OrderDeliveriesTable = (props) => {

  const renderStatusList = (status, type) => {
    return status.map((item, key) => {
      return (
        <>
          {item.slug === "assigned" && type === "pickup" && (
            <tr key={key + 200}>
              <td>Assigned</td>
              <td>{moment(item.created_at).format("DD MMMM, yyyy, h:mm:ss A")}</td>
              <td>
                {item.lat && item.lon ? <a href={`https://maps.google.com/?q=${item.lat},${item.lon}`} target="_blank"><EnvironmentOutlined /></a>
                :"-" }
              </td>
              <td>{"-"}</td>
              <td>{"-"}</td>
            </tr>
          )}
          {(item.slug === "cancel" && type === "pickup") ||
          (item.slug === "un-assigned" && type === "delivery") ||
          (item.slug === "assigned" && type === "delivery") ? (
            ""
          ) : (
            <tr key={key}>
              {/* <td>{type}-{item.slug}</td>   */}
              <td>{orderStatuses(item.slug, type, item.title)}</td>
              <td>{moment(item.created_at).format("DD MMMM, yyyy, h:mm:ss A")}</td>
              <td>
                {item.lat && item.lon ? <a href={`https://maps.google.com/?q=${item.lat},${item.lon}`} target="_blank"><EnvironmentOutlined /></a>
                :"-" }
              </td>
              <td>{item.reason || "-" }</td>
              <td>{( item.fake_gps == null ? "-" : (item.fake_gps == true ? "Yes" : "No")) || "-" }</td>
            </tr>
          )}
        </>
      );
    });
  };

  const superstoreBtnStatuses = (values) => {
    let storerype = true;
    values && values.find((item)=>{
      if(item.store.type === "superstore"){
        storerype = false;
      }
    });
    return storerype;
  }
  
  const unassignBtnStatuses = (values) => {  
    const data = values && values.find((item)=>{
      if(item.job_type == "pickup") {
        return true;
      }
    });
    const result = data && data.status.find((d)=>d.current == true && (d.slug == "assigned" || d.slug == "started" || d.slug ==  "arrived"));
    return result || result != undefined?false:true;
  }

  return (
    <Card title="Deliveries" bordered>
      <div className="customTable">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>3PL ID</th>
              <th>Status</th>
              <th>Redelivery</th>
              <th>Pickup</th>
              <th>Dropoff</th>
              <th>Zone</th>
              <th>Fleet ID</th>
              <th>Courier</th>
              <th>Utilization</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{props.orderData ? props.orderData.order_id : "-"}</td>
              <td>{props.orderData ? props.orderData.order_id : "-"}</td>
              <td>
                {props.orderData &&
                  props.orderData.status.map((item) => {
                    if (item.current == true) {
                      return orderStatuses(
                        item.slug,
                        props.orderData.job_type,
                        item.title
                      ); // item.title;
                    }
                  })}
              </td>
              <td>-</td>
              <td>{props.orderData ? props.orderData.pickup.address : ""}</td>
              <td>{props.orderData ? props.orderData.delivery.address : ""}</td>
              <td>{props.orderData ? props.orderData.store.zone : "-"}</td>
              <td>{props.orderData ? props.orderData.store.storeId : ""}</td>
              <td>
                {props.orderData ? (
                  <a onClick={props.showOrderRiderModal}>
                    {props.orderData.rider.fullName}
                  </a>
                ) : (
                  ""
                )}
              </td>
              <td>-</td>
              <td>
                <Space direction="vertical">
                  {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_FORCE_RE_ASSIGN) ?
                    <Tooltip title="Force Reassign">
                      <Button disabled={taskButtonStatuses(props.orderDatatwice, "")} onClick={props.showOrderReassignModal}>
                        <UserOutlined />
                      </Button>
                    </Tooltip>
                    :
                    ""             
                  }
                  {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_UN_ASSIGN) ?
                    <Tooltip title="Un Assign">
                      <Button disabled={superstoreBtnStatuses(props.orderDatatwice) === false?false:(taskButtonStatuses(props.orderDatatwice, "") || unassignBtnStatuses(props.orderDatatwice))} onClick={props.showOrderUnassignModal}>
                        <UserDeleteOutlined />
                      </Button>
                    </Tooltip>
                    :
                    ""             
                  }
                  { 
                    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_INITIAL_COMPLETE) &&
                    (
                      userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_COMPLETE) ? 
                        <Tooltip title="Order Complete">
                        <Button disabled={taskButtonStatuses(props.orderDatatwice, "called_from_complete")} onClick={props.showOrderCompleteModal}><DoubleRightOutlined /></Button>
                        </Tooltip>
                      : 
                        <Tooltip title="Order Complete">
                          <Button disabled={taskButtonStatuses(props.orderDatatwice, "")} onClick={props.showOrderCompleteModal}><DoubleRightOutlined /></Button>
                        </Tooltip>
                    )
                  }
                  { 
                    userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_INITIAL_CANCEL) &&
                    (
                      userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ORDER_CANCEL) ? 
                        <Tooltip title="Order Cancel">
                          <Button disabled={taskButtonStatuses(props.orderDatatwice, "called_from_cancel")} onClick={props.showOrderCancelModal}><CloseOutlined /></Button>
                        </Tooltip>
                      :
                        <Tooltip title="Order Cancel">
                          <Button disabled={taskButtonStatuses(props.orderDatatwice, "")} onClick={props.showOrderCancelModal}><CloseOutlined /></Button>
                        </Tooltip>
                    )
                  }
                </Space>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Collapse accordion>
        <Panel header="Deliveries Detail" key="1">
          <div className="customTable">
            <table>
              <thead>
                <tr>
                  <th>Event</th>
                  <th>Time</th>
                  <th>Loc</th>
                  <th>Reason</th>
                  <th>Using fake gps</th>
                </tr>
              </thead>
              <tbody>
                {props.orderDatatwice &&
                  props.orderDatatwice.map((item, key) => {
                    return renderStatusList(item.status, item.job_type);
                  })}
              </tbody>
            </table>
          </div>
        </Panel>
      </Collapse>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    emailUser: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};

export default connect(mapStateToProps)(OrderDeliveriesTable);